/* GENERATED from template-src/page.html by build-section.py — do not
   edit this file; edit page.html and re-run the script.

   Defines window.DD_INIT and window.DD_BOOT. The section supplies the
   data and calls them; see the bootstrap in the .liquid file. */

window.DD_INIT = function(P){
"use strict";

/* ============================================================
   DATA — mirrors the Dermal Health Science content hub.
   In production this block is replaced by a fetch of
   /v1/diagnosis/AOPB from the admin worker.
   ============================================================ */

var PRODUCTS = {
  pcc100:   { name:"Pore Control Cleanser", size:"100 ml", price:499,  sku:"DX-PCC100" },
  pcc175:   { name:"Pore Control Cleanser", size:"175 ml", price:764,  sku:"DX-PCC175" },
  inflacin: { name:"Inflacin Serum",        size:"30 ml",  price:895,  sku:"DX-IS" },
  retinol:  { name:"Retinol Serum",         size:"30 ml",  price:1395, sku:"DX-RET" },
  litaderm: { name:"Litaderm Serum",        size:"30 ml",  price:1350, sku:"DX-LIT" },
  salicylic:{ name:"Salicylic Gel",         size:"30 ml",  price:892,  sku:"DX-SG" },
  spf:      { name:"Dermdefence SPF 50",    size:"50 ml",  price:592,  sku:"DX-DERMD" }
};

/* discount ladder from the pack pricing model */
var DISCOUNT = { 4:0.08, 5:0.10, 6:0.12, 7:0.14 };

/* The built-in list is what the page falls back to when it has no protocol to
   show — a staff preview, a theme-editor preview that lost its ?k=, or a
   record that could not be fetched. It used to carry no slugs, so hydrate()
   returned immediately and the modal showed only these hard-coded paragraphs:
   no benefits, no pharmacology, and no request in the network tab to explain
   why. The slugs mean the fallback reads from the ingredient library too, so
   what you see while previewing is what a patient sees. */
var ELEMENTS = [
  {
    /* The slug must match what the protocols actually link to. Retinol Serum
       contains hydroxypinacolone retinoate, not retinol, so the library entry
       is `retinoic-acid-analogue` — displayed to the customer as "Retinol",
       which is the word the public knows. Pointing this at "retinol" made
       hydrate() fetch the wrong molecule's pharmacology. */
    slug:"retinoic-acid-analogue", code:"Rol", name:"Retinol", sub:"Vitamin A", role:"Renewal & collagen",
    body:"A next-generation retinoid that binds the retinoic-acid receptor directly, without the conversion steps retinol needs. It accelerates cellular turnover, normalises keratinisation inside the pore, and stimulates fibroblasts to produce new collagen — improving firmness, texture and the appearance of fine lines, with markedly less irritation.",
    effects:[
      "Accelerates epidermal cell turnover and exfoliation.",
      "Stimulates collagen synthesis, improving firmness and fine lines.",
      "Normalises follicular keratinisation to prevent comedones.",
      "Helps fade post-inflammatory pigmentation over time."
    ],
    conditions:["Photoaging & fine lines","Acne & congestion","Uneven tone & pigmentation"],
    refs:[
      "Mukherjee, S. et al. (2006). Retinoids in the treatment of skin aging. Clinical Interventions in Aging.",
      "Kang, S. et al. (2005). Application of retinol to human skin. Journal of Investigative Dermatology."
    ]
  },
  {
    slug:"salicylic-acid", code:"Sa", name:"Salicylic acid", sub:"Beta-hydroxy acid", role:"Pore control",
    body:"Salicylic acid is a beta-hydroxy acid that is oil-soluble, allowing it to penetrate sebum and exfoliate inside the pore lining. It dissolves the debris that causes blackheads and congestion, and brings mild anti-inflammatory action — making it a cornerstone active for oily, breakout-prone skin.",
    effects:[
      "Penetrates sebum to exfoliate inside the pore.",
      "Dissolves debris that forms blackheads and whiteheads.",
      "Mild anti-inflammatory effect on active breakouts.",
      "Refines the appearance of enlarged pores."
    ],
    conditions:["Oily & congested skin","Comedonal acne","Enlarged pores"],
    refs:[
      "Arif, T. (2015). Salicylic acid as a peeling agent. Clinical, Cosmetic & Investigational Dermatology.",
      "Zander, E. & Weisman, S. (1992). Treatment of acne vulgaris with salicylic acid. Clinical Therapeutics."
    ]
  },
  {
    slug:"niacinamide", code:"Nc", name:"Niacinamide", sub:"Vitamin B3", role:"Tone & barrier",
    body:"Niacinamide offers several benefits for the skin, primarily due to its anti-inflammatory and antioxidant properties. It reduces the redness and inflammation associated with acne and rosacea, improves the skin's barrier function, regulates sebum, and decreases the transfer of melanin to the epidermis — helping to fade dark spots and even out skin tone. It also supports collagen production, softening fine lines.",
    effects:[
      "Barrier enhancement by increasing ceramide production.",
      "Notable anti-inflammatory action, reducing redness.",
      "Regulates sebum production in oily, acne-prone skin.",
      "Inhibits melanosome transfer to even skin tone.",
      "Boosts collagen and improves elasticity.",
      "Antioxidant protection against UV and pollution."
    ],
    conditions:["Acne & oily skin","Hyperpigmentation & melasma","Aging skin","Barrier disorders & eczema","Photodamage"],
    refs:[
      "Gehring, W. (2004). Nicotinic acid/niacinamide and the skin. Journal of Cosmetic Dermatology.",
      "Bissett, D. L., Oblong, J. E. & Berge, C. A. (2005). Niacinamide: a B vitamin that improves aging facial skin appearance. Dermatologic Surgery.",
      "Snaidr, V. A., Damian, D. L. & Halliday, G. M. (2019). Nicotinamide for photoprotection and skin cancer chemoprevention. Experimental Dermatology.",
      "Navarrete-Solís, J. et al. (2011). Niacinamide 4% vs Hydroquinone 4% in melasma. Dermatology Research and Practice."
    ]
  },
  {
    slug:"azelaic-acid", code:"Az", name:"Azelaic acid", sub:"C9 dicarboxylic acid", role:"Calm & clarify",
    body:"Azelaic acid is a multitasking dicarboxylic acid that calms inflammation, normalises keratinisation, and inhibits tyrosinase. It is uniquely suited to skin where acne, redness and pigmentation overlap — reducing C. acnes, soothing papules and pustules, and fading the marks they leave behind.",
    effects:[
      "Anti-inflammatory action calms papules and redness.",
      "Antibacterial against acne-causing bacteria.",
      "Inhibits tyrosinase to fade post-acne pigmentation.",
      "Normalises keratinisation to reduce comedones."
    ],
    conditions:["Inflammatory acne","Rosacea & redness","Post-inflammatory pigment"],
    refs:[
      "Fitton, A. & Goa, K. L. (1991). Azelaic acid: a review. Drugs.",
      "Schulte, B. C. et al. (2015). Azelaic acid in dermatology. Journal of Drugs in Dermatology."
    ]
  },
  {
    slug:"arbutin", code:"Ar", name:"Arbutin", sub:"α-Arbutin", role:"Brightening",
    body:"Arbutin is a naturally derived hydroquinone glycoside that releases its brightening action gradually and gently. It competitively inhibits tyrosinase — the rate-limiting enzyme in melanin synthesis — reducing the formation of new pigment without the irritation associated with stronger agents.",
    effects:[
      "Inhibits tyrosinase to reduce new melanin production.",
      "Fades existing dark spots and evens skin tone.",
      "Gentler alternative to hydroquinone with lower irritation.",
      "Supports a brighter, more uniform complexion."
    ],
    conditions:["Hyperpigmentation & melasma","Post-inflammatory pigment","Dull, uneven tone"],
    refs:[
      "Maeda, K. & Fukuda, M. (1996). Arbutin: mechanism of its depigmenting action. Journal of Pharmacology and Experimental Therapeutics.",
      "Boissy, R. E. et al. (2005). DeoxyArbutin: a novel depigmenting agent. Experimental Dermatology."
    ]
  },
  {
    slug:"zinc-pca", code:"Zn", name:"Zinc PCA", sub:"Zinc salt of PCA", role:"Oil & defence",
    body:"Zinc PCA pairs the sebum-regulating, antibacterial properties of zinc with the humectant PCA molecule. It helps reduce excess oil, calms inflammation, and supports the skin against acne-causing bacteria — all while helping the skin retain moisture, an ideal balance for oily yet reactive skin.",
    effects:[
      "Regulates sebaceous activity to reduce excess oil.",
      "Antibacterial support against acne-causing bacteria.",
      "Soothes inflammation and reactive skin.",
      "Humectant PCA helps maintain hydration."
    ],
    conditions:["Oily & acne-prone skin","Inflammatory breakouts","Reactive skin"],
    refs:[
      "Schwartz, J. R. et al. (2013). Zinc and skin health. Dermatologic Therapy.",
      "Gupta, M. et al. (2014). Zinc therapy in dermatology: a review. Dermatology Research and Practice."
    ]
  },
  {
    slug:"sunscreen", code:"Spf", name:"Sunscreen", sub:"SPF 50 · broad spectrum", role:"Daily shield",
    body:"Broad-spectrum sunscreen is the single most important step for almost every skin profile. UV exposure drives photoaging, deepens pigmentation, and triggers inflammation that feeds the entire cycle. Daily SPF protects the gains made by every other active — preventing new dark spots and safeguarding DNA from UV-induced damage.",
    effects:[
      "Shields against UVA/UVB to prevent photoaging.",
      "Prevents UV-triggered melanin and new dark spots.",
      "Reduces UV-driven inflammation and barrier stress.",
      "Protects the results of all other treatment actives."
    ],
    conditions:["All pigmentation concerns","Photoaging prevention","Post-procedure protection"],
    refs:[
      "Hughes, M. C. B. et al. (2013). Sunscreen and prevention of skin aging. Annals of Internal Medicine.",
      "Passeron, T. et al. (2021). Photoprotection and melasma. Journal of the EADV."
    ]
  }
];

/* Four bipolar axes, as the assessment scores them.
   `pole` > 50 means the trait named on the right is expressed. */
/* The four measured axes, keyed so a hero row can ask for one by name. */
var AXMETA = {
  aging:{ param:"aging_perc", name:"Firmness",   left:"Tight",         right:"Aging",      sample:78,
          read:function(v){ return v >= 50 ? "Aging" : "Tight"; } },
  oil:  { param:"hyd_perc",   name:"Hydration",  left:"Dry",           right:"Oily",       sample:71,
          read:function(v){ return v >= 50 ? "Oily" : "Dry"; } },
  pig:  { param:"pigm_perc",  name:"Pigment",    left:"Non-pigmented", right:"Pigmented",  sample:64,
          read:function(v){ return v >= 50 ? "Pigmented" : "Non-pigmented"; } },
  inf:  { param:"final_inf",  name:"Reactivity", left:"Resistant",     right:"Inflamed",   sample:66,
          read:function(v){ return v >= 50 ? "Inflamed" : "Resistant"; } }
};
var AX_ORDER = ["oil","inf","pig","aging"];

/* Resolve every axis once, from the assessment hand-off in the URL when it is
   there and the sample otherwise, and mark which one is furthest from centre —
   that is the axis the page gives copper to. */
var AXVALS = {}, AXLEAD = null;
(function(){
  var q = new URLSearchParams(window.location.search), best = -1;
  /* Supplied by the section from the submission record. The URL is the
     fallback for hand-written links; the built-in samples are a LAST
     resort and mark the page as a sample so invented numbers can never
     be mistaken for someone's results. */
  var supplied = window.DD_AXES || null;
  var anyReal = false;
  AX_ORDER.forEach(function(k){
    var raw = (supplied && supplied[k] != null) ? supplied[k] : q.get(AXMETA[k].param);
    var real = raw != null && raw !== "" && !isNaN(parseFloat(raw));
    if (real) anyReal = true;
    var v = real ? Math.max(0, Math.min(100, parseFloat(raw))) : AXMETA[k].sample;
    AXVALS[k] = v;
    var d = Math.abs(v - 50);
    if(d > best){ best = d; AXLEAD = k; }
  });
  /* the analysis sequence shows the same four numbers it is about to reveal */
  window.DD_AXES_SAMPLE = !anyReal;
  window.DD_AXES_PREVIEW = AX_ORDER.map(function(k){
    return { name: AXMETA[k].name, v: AXVALS[k], read: AXMETA[k].read(AXVALS[k]) };
  });
})();

/* ============================================================ HELPERS */
var $  = function(s,r){ return (r||document).querySelector(s); };
var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
function el(tag, cls, txt){ var n=document.createElement(tag); if(cls) n.className=cls; if(txt!=null) n.textContent=txt; return n; }
function money(n){ return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g,"\u00A0"); }
function clamp(n,a,b){ return Math.max(a, Math.min(b, n)); }

/* ============================================================ API BINDING
   The page is a template. Everything specific to one diagnosis comes from
   GET /v1/diagnosis/<code>, so editing a profile in the admin changes what
   this page says. When the fetch fails the markup already in the document
   stands as-is — a stale page beats a broken one. */
/* A title is trait words separated by dots — but a variant appends a qualifier
   to the last one ("Breakouts · Pregnancy"). Split that off so it never lands
   inside a trait row; it belongs on the eyebrow, where it qualifies the whole
   diagnosis rather than one axis. */
function ddTitleParts(P){
  var words = String((P && P.title) || "").split(".")
    .map(function(w){ return w.trim(); }).filter(Boolean);
  var suffix = null;
  if(words.length){
    var m = /^([\s\S]*?)\s+·\s+([\s\S]+)$/.exec(words[words.length - 1]);
    if(m){ words[words.length - 1] = m[1].trim(); suffix = m[2].trim(); }
  }
  /* Eight of the sixty-nine titles glue two traits together with a severity:
     "Pigmentation with mild Breakouts", "Oily with mild Breakouts". Left whole
     they put the inflammation trait inside the PIGMENT row and leave the row
     that actually owns it — the one whose letter is B — reading "Reactivity",
     the generic axis name. Split here, once, so every trait gets its own row
     and the severity travels with the trait it describes rather than with the
     one it happened to be typed after. */
  var mod = null, modIndex = -1;
  if(words.length){
    var last = words[words.length - 1];
    var w = /^([\s\S]+?)\s+with\s+(mild)\s+([\s\S]+)$/i.exec(last);
    if(w){
      words[words.length - 1] = w[1].trim();
      words.push(w[3].trim());
      mod = w[2].toLowerCase();
      modIndex = words.length - 1;
    }
  }
  return { words: words, suffix: suffix, mod: mod, modIndex: modIndex };
}

/* The title as a sentence again, for the screen-reader h1 and the page title:
   splitting it for the rows must not lose the word "mild". */
function ddTitleLine(P){
  var t = ddTitleParts(P);
  return t.words.map(function(w, i){
    return (i === t.modIndex && t.mod) ? (t.mod + " " + w) : w;
  }).join(" · ") + (t.suffix ? " · " + t.suffix : "");
}
function ddLines(v){ return (v==null?[]:(Array.isArray(v)?v:String(v).split("\n"))).map(function(x){return String(x).trim();}).filter(Boolean); }
function ddSet(sel, txt){ var n=$(sel); if(n && txt!=null && txt!=="") n.textContent=txt; }
function ddList(sel, items, build){
  var host=$(sel); if(!host || !items || !items.length) return;
  host.innerHTML="";
  items.forEach(function(it){ host.appendChild(build(it)); });
}

function paintFromAPI(P){
  var parts = ddTitleParts(P), words = parts.words;
  var eye = $("#hcEyebrow");
  if(eye) eye.textContent = "Your diagnosis" + (parts.suffix ? " · " + parts.suffix : "");
  var code  = String(P.code||"").replace(/-/g," ").trim();

  /* ---- hero -------------------------------------------------------- */
  /* The visible headline is the stack itself — one row per trait — so the h1
     here is for screen readers and search engines only. It is also why nothing
     in the title can wrap badly any more: there is no long headline to break. */
  var h1 = $("#hcH1");
  if(h1) h1.textContent = ddTitleLine(P) + " — Dermal Diagnosis " + (P.code || "");
  if(P.lede) ddSet("#hcLede", P.lede);
  ddSet("#hcCode", String(P.code || "").indexOf("-") > -1
        ? String(P.code).split("-").join(" · ")
        : String(P.code || "").split("").join(" "));
  if(P.pack && P.pack.sku){
    ddSet("#hcPack", "Pack " + P.pack.sku + " · " + (P.pack.product_count || 0) + " products");
  }
  ddSet("#hcReview", "Reassess in " + (P.review_weeks || 12) + " weeks");

  /* ---- profile ----------------------------------------------------- */
  var prose=$("#profile .dd-prose");
  if(prose && P.description){
    prose.innerHTML="";
    String(P.description).split(/\n\s*\n/).forEach(function(par){
      var t=par.trim(); if(t) prose.appendChild(el("p",null,t));
    });
  }
  ddList("#profile .dd-ledger__row:nth-child(1) .dd-ledger__v ul", P.characteristics,
         function(t){ return el("li",null,t); });

  var rows=$$("#profile .dd-ledger__row");
  if(rows[1] && P.pack){
    var b=rows[1].querySelector("b");
    if(b) b.textContent=(P.pack.sku||"")+" · "+(P.pack.product_count||0)+" products";
  }
  if(rows[2] && P.pack && P.pack.first){
    var b2=rows[2].querySelector("b"); if(b2) b2.textContent=P.pack.first;
  }
  if(rows[3]){
    var b3=rows[3].querySelector("b"); if(b3) b3.textContent=(P.review_weeks||12)+" weeks";
  }

  function pointList(sel, items){
    ddList(sel, items, function(p){
      var li=el("li"); li.appendChild(el("b",null,p.title)); li.appendChild(el("span",null,p.body||""));
      return li;
    });
  }
  pointList(".dd-force--for ul", P.benefits);
  pointList(".dd-force--against ul", P.barriers);
  ddList(".dd-shift__col--from ul", P.frustrations, function(t){ return el("li",null,t); });
  ddList(".dd-shift__col--to ul",   P.goals,        function(t){ return el("li",null,t); });

  /* ---- objectives --------------------------------------------------- */
  ddList(".dd-objs", P.objectives, function(o){
    var d=el("div","dd-obj");
    var ic=el("span","dd-obj__ic");
    ic.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><use href="#i-'+ddEsc(o.icon||"spark")+'"/></svg>';
    d.appendChild(ic);
    d.appendChild(el("h3",null,o.title));
    d.appendChild(el("p",null,o.body||""));
    return d;
  });
  var oh=$("#objectives .dd-head h2");
  if(oh && P.objectives && P.objectives.length){
    oh.textContent = ddCount(P.objectives.length)+" things your protocol has to do";
  }

  /* ---- actives ------------------------------------------------------ */
  /* The heading counted to seven in the markup and was never recomputed, so
     sixty-three of the sixty-nine protocols announced a number they did not
     have. The objectives heading below already counts from the data; this one
     was simply forgotten. */
  var ah = $("#actives .dd-head h2");
  if(ah && P.actives && P.actives.length){
    ah.textContent = ddCount(P.actives.length) + " molecules doing the work";
  }
  if(P.actives && P.actives.length){
    ELEMENTS = P.actives.map(function(a){
      return { slug:a.slug, code:a.code||"", name:a.name||a.slug, sub:"", role:"",
               body:a.description||"", effects:[], conditions:[], refs:[], loaded:false };
    });
  }

  /* ---- protocol ------------------------------------------------------ */
  function steps(panelSel, list){
    var panel=$(panelSel); if(!panel || !list || !list.length) return;
    $$(".dd-step", panel).forEach(function(n){ n.remove(); });
    var anchor=panel.querySelector(".dd-intensify");
    list.forEach(function(s,i){
      var d=el("div","dd-step");
      d.appendChild(el("span","dd-step__n", String(i+1)));
      var mid=el("div");
      mid.appendChild(el("span","dd-step__role", s.role||""));
      var nm=el("div","dd-step__nm");
      nm.appendChild(document.createTextNode(s.product_title||s.product_handle||""));
      if(s.alt_title||s.alt_handle){
        var alt=el("span",null," "+(s.alt_conjunction||"alternating with")+" "+(s.alt_title||s.alt_handle));
        alt.setAttribute("style","color:var(--muted);font-weight:400");
        nm.appendChild(alt);
      }
      mid.appendChild(nm);
      if(s.body) mid.appendChild(el("p","dd-step__d", s.body));
      d.appendChild(mid);
      d.appendChild(el("span","dd-step__price", (s.size_label||"").replace(" "," ")));
      panel.insertBefore(d, anchor);
    });
  }
  steps("#panel-am", P.regimen && P.regimen.am);
  steps("#panel-pm", P.regimen && P.regimen.pm);

  function intensify(bodySel, blocks, titleFallback){
    var body=$(bodySel); if(!body) return;
    var wrap=body.closest(".dd-intensify");
    if(!blocks || !blocks.length){ if(wrap) wrap.hidden=true; return; }
    if(wrap) wrap.hidden=false;
    var b=blocks[0];
    var t=wrap && wrap.querySelector(".dd-intensify__t");
    var sub=wrap && wrap.querySelector(".dd-intensify__s");
    if(t) t.textContent = b.title || titleFallback;
    if(sub && b.subtext) sub.textContent = b.subtext;
    var ul=body.querySelector("ul");
    if(ul && b.items && b.items.length){
      ul.innerHTML="";
      b.items.forEach(function(x){ ul.appendChild(el("li",null,x)); });
    }
  }
  intensify("#int-am", P.regimen && P.regimen.intensify_am, "Intensify — morning");
  intensify("#int-pm", P.regimen && P.regimen.intensify_pm, "Intensify — evening");

  ddList(".dd-io__col--avoid ul",   P.regimen && P.regimen.avoid,   function(t){ return el("li",null,t); });
  ddList(".dd-io__col--include ul", P.regimen && P.regimen.include, function(t){ return el("li",null,t); });

  /* ---- tolerance ramp ------------------------------------------------ */
  var ramp=$(".dd-ramp table");
  if(ramp && P.ramp && P.ramp.rows && P.ramp.rows.length){
    var hd=P.ramp.headers||[];
    var thead=ramp.querySelector("thead tr");
    if(thead && hd.length){
      thead.innerHTML="";
      hd.forEach(function(h){ var th=el("th",null,h); th.setAttribute("scope","col"); thead.appendChild(th); });
    }
    var tb=ramp.querySelector("tbody");
    if(tb){
      tb.innerHTML="";
      P.ramp.rows.forEach(function(r){
        var tr=el("tr");
        var th=el("th",null,r.week_label); th.setAttribute("scope","row"); tr.appendChild(th);
        [r.col1,r.col2,r.col3].slice(0, Math.max(1,hd.length-1)).forEach(function(c){
          tr.appendChild(el("td",null,c||"—"));
        });
        tb.appendChild(tr);
      });
    }
  } else if(ramp && (!P.ramp || !P.ramp.rows || !P.ramp.rows.length)){
    var rw=$(".dd-ramp"); if(rw) rw.hidden=true;
  }

  /* The note under the ramp. It is part of the table, so it lives and dies
     with it: a protocol with no ramp told the reader to "step back one week on
     this table" while the table itself was hidden. Body lines are escaped —
     only the authored title is allowed to be bold — because this text is
     edited in the admin and nothing there should be able to inject markup into
     a patient's page. */
  var rnote = $("#rampNote");
  if(rnote){
    var rn = (P.ramp && P.ramp.note) || null;
    var rbody = rn ? (rn.items || []).filter(Boolean).join(" ") : "";
    var hasRamp = !!(P.ramp && P.ramp.rows && P.ramp.rows.length);
    if(hasRamp && rbody){
      rnote.innerHTML = (rn.title ? "<b>" + ddEsc(rn.title) + "</b> " : "") + ddEsc(rbody);
      rnote.hidden = false;
    } else {
      rnote.hidden = true;
    }
  }

  /* ---- pack ---------------------------------------------------------- */
  ddSet(".dd-pack h2", "Dermal Diagnosis™ | "+P.code);
  if(P.pack && P.pack.lede) ddSet(".dd-pack__lede", P.pack.lede);
  if(P.pack && P.pack.sku) ddSet("#pk-sku", "SKU · "+P.pack.sku);
  if(P.pack && P.pack.items && P.pack.items.length){
    PRODUCTS = {}; PACK_ITEMS = P.pack.items;
    P.pack.items.forEach(function(it,i){
      PRODUCTS["p"+i] = { name:it.title||it.handle, size:it.size_label||"", price:null,
                          handle:it.handle, group:it.variant_group, value:it.variant_value,
                          optional:!!it.optional };
    });
  }
  ddList(".dd-phases", P.phases, function(ph){
    var d=el("div","dd-phase");
    d.appendChild(el("span","dd-phase__n", ph.label));
    d.appendChild(el("h4",null,ph.title));
    var ul=el("ul");
    (ph.items||[]).forEach(function(x){ ul.appendChild(el("li",null,ddName(x,P))); });
    d.appendChild(ul);
    if(ph.body) d.appendChild(el("p",null,ph.body));
    return d;
  });

  /* ---- timeline ------------------------------------------------------- */
  ddList(".dd-tl", P.timeline, function(t){
    var d=el("div","dd-tl__c");
    d.appendChild(el("span","dd-tl__w", t.window_label));
    d.appendChild(el("h4",null,t.title));
    d.appendChild(el("p",null,t.body||""));
    var bar=el("div","dd-tl__bar"), i2=el("i");
    i2.setAttribute("data-tlbar", String(t.progress||0));
    bar.appendChild(i2); d.appendChild(bar);
    return d;
  });

  /* ---- footer / draft notice ------------------------------------------ */
  var fm=$(".dd-foot__bar .dd-mono");
  if(fm) fm.textContent = (P.pack && P.pack.sku ? P.pack.sku : P.code) +
     (P.clinically_signed_off ? "" : " · awaiting clinical sign-off");
  var draft=$(".dd-draft");
  if(draft && P.clinically_signed_off) draft.hidden = true;
}

/* the objectives heading counts whatever came back */
function ddCount(n){
  var w=["Zero","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten"];
  return w[n] || String(n);
}
function ddEsc(s){ return String(s==null?"":s).replace(/[&<>"]/g, function(c){
  return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
/* Parse untrusted markup INERTLY. Assigning innerHTML — even to a detached div —
   still makes the browser fetch <img src>, which fires onerror handlers; a
   DOMParser document is inert, so nothing loads and nothing runs. Without
   DOMParser we do not parse at all, we strip to text. */
function ddParse(html){
  var str = String(html == null ? "" : html);
  if(window.DOMParser){
    try { return new DOMParser().parseFromString("<body>" + str + "</body>", "text/html").body; }
    catch(e){}
  }
  var d = document.createElement("div");
  d.textContent = str.replace(/<[^>]*>/g, "");
  return d;
}
function ddStrip(html){ return ddParse(html).textContent.trim(); }
/* The ingredient library writes its one emphasised phrase as <em> — the copper
   italic accent from the brand system. That emphasis is meant, so it survives;
   everything else in the string does not. Unknown elements are unwrapped (their
   words kept), script and style are dropped whole, and every attribute goes, so
   nothing that arrives from the database can carry behaviour into the page. */
function ddRich(html){
  var host = ddParse(html);
  /* li/br/sup/sub are structure, not behaviour: kept, attributes stripped.
     p and div are unwrapped, with a line break between consecutive ones so
     two paragraphs don't read as one run-on sentence. */
  var KEEP = { em:1, i:1, b:1, strong:1, li:1, br:1, sup:1, sub:1 };
  var BLOCK = { p:1, div:1 };
  function moreAfter(n){
    for(var s=n.nextSibling; s; s=s.nextSibling){ if(/\S/.test(s.textContent||"")) return true; }
    return false;
  }
  (function walk(node){
    var kids = Array.prototype.slice.call(node.childNodes);
    for(var i=0;i<kids.length;i++){
      var n = kids[i];
      if(n.nodeType === 3) continue;                       /* text: leave it */
      if(n.nodeType !== 1){ node.removeChild(n); continue; } /* comments etc. */
      var tag = n.tagName.toLowerCase();
      if(tag === "script" || tag === "style"){ node.removeChild(n); continue; }
      /* Inside first. Unwrapping moves the children up into a list this loop
         has already taken, so they were never visited: a <ul>'s <li>s kept every
         attribute they were pasted with. */
      walk(n);
      if(!KEEP[tag]){
        var gap = BLOCK[tag] && /\S/.test(n.textContent) && moreAfter(n);
        while(n.firstChild) node.insertBefore(n.firstChild, n);
        if(gap) node.insertBefore(n.ownerDocument.createElement("br"), n);
        node.removeChild(n);
        continue;
      }
      while(n.attributes.length) n.removeAttribute(n.attributes[0].name);
    }
  })(host);
  return host.innerHTML;
}
/* true when a fragment has actual words in it, not just empty tags */
function ddHasText(html){ return ddStrip(html).length > 0; }
/* managing_conditions comes in three shapes since the admin moved to a rich-text
   editor: a plain comma list (the original), a <p> holding a comma list, and a
   <ul> of "Condition: why it helps" items. It used to be split on , and ; as raw
   text, so in the HTML shapes every &nbsp; became a chip boundary and the tags
   printed as words. Parsed first now:
     - list items that explain themselves (a bold label, or "Name: ...") -> rows
     - bare names, or a comma list                                     -> chips  */
function ddChip(s){
  s = String(s || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim().replace(/\.$/, "");
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
}
function ddConditions(html){
  var root = ddParse(html);
  var lis = Array.prototype.filter.call(root.querySelectorAll("li"), function(li){
    var up = li.parentNode;
    return !(up && up.closest && up.closest("li")) && ddChip(li.textContent);
  });
  if(lis.length){
    var explained = lis.some(function(li){
      return li.querySelector("b,strong") || /:\s/.test(li.textContent);
    });
    return explained
      ? { rows: lis.map(function(li){ return ddRich(li.innerHTML); }) }
      : { chips: lis.map(function(li){ return ddChip(li.textContent); }) };
  }
  /* a paragraph or <br> ends an item just as a comma does */
  Array.prototype.forEach.call(root.querySelectorAll("p,div,br"), function(n){
    n.parentNode.insertBefore(n.ownerDocument.createTextNode("\n"), n.nextSibling);
  });
  return { chips: ddSplitList(root.textContent).map(ddChip).filter(Boolean) };
}
/* Split a written list on , ; line breaks and full stops between sentences, but
   never inside brackets — "wrinkles (forehead, crow's feet)" is one item — and
   drop the "and" that introduces the last item. */
function ddSplitList(t){
  var out = [], cur = "", depth = 0, s = String(t || "");
  for(var i = 0; i < s.length; i++){
    var c = s.charAt(i);
    if(c === "(") depth++;
    else if(c === ")") depth = Math.max(0, depth - 1);
    var sentence = c === "." && /\s/.test(s.charAt(i + 1)) && /[A-Z]/.test(s.slice(i + 1).trim().charAt(0));
    if(depth === 0 && (c === "," || c === ";" || c === "\n" || sentence)){ out.push(cur); cur = ""; continue; }
    cur += c;
  }
  out.push(cur);
  return out.map(function(x){ return x.trim().replace(/^(and|or)\s+/i, ""); });
}
/* pack phases store product handles; show the name the pack uses */
function ddName(handle,P){
  var it=(P.pack&&P.pack.items||[]).filter(function(x){ return x.handle===handle; })[0];
  return it ? (it.title||handle) : handle;
}
var PACK_ITEMS = null;

if(P) { try { paintFromAPI(P); } catch(e){ if(window.console) console.warn('[dd] paint failed', e); } }

var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ============================================================ THEME
   Removed. The theme's own header owns the light/dark control (see
   snippets/dhs-theme-toggle.liquid and assets/dhs-foundation.js), and it sets
   data-theme on <html> — which is the same hook this page's CSS reads. Two
   switches for one setting is a bug waiting to be reported, and two listeners
   writing the same attribute is worse. The @media (prefers-color-scheme)
   rules still cover the case where nothing has been chosen. */

/* ============================================================ TOP BAR OFFSET
   This page carries its own sticky section nav, and it is embedded in a theme
   that has its own sticky header. Both wanted top:0, and ours won — it parked
   across the store logo and, because the bar is full width, it swallowed
   clicks on the theme's own controls all the way out to the cart icon at the
   far right. (The pointer-events half of that is fixed in the stylesheet.)

   The height of the theme's header is not ours to hard-code: it is a theme
   setting, it differs per breakpoint, and it will change again. So it is
   measured. We look for a sticky-or-fixed element resting at the top of the
   viewport, at least most of the window wide, that is neither us nor one of
   our ancestors — and take the lowest edge among them.

   Two guards, both learned from what is actually on this page:
     - anything taller than 40% of the window is not a header. The theme ships
       a full-viewport <loading-bar> fixed at top:0, and without this the nav
       would be pushed a screen and a half down the page.
     - anything invisible or click-through is not a header either: the same
       theme has a full-screen transparent overlay at top:0.

   Re-measured on resize and on scroll, because a header that shrinks or hides
   as you scroll is common and this must not leave a hole where it used to be.
   Falls back to 0 — the old behaviour — when there is no sticky header, which
   is the case for the standalone preview. */
(function(){
  var bar = document.getElementById("topbar");
  if (!bar) return;
  var last = -1;

  function candidates(){
    var out = [], all = document.body.querySelectorAll("*");
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (el === bar || el.contains(bar) || bar.contains(el)) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== "sticky" && cs.position !== "fixed") continue;
      if (cs.visibility === "hidden" || cs.pointerEvents === "none" || parseFloat(cs.opacity) < 0.05) continue;
      var r = el.getBoundingClientRect();
      if (r.width < window.innerWidth * 0.9) continue;
      if (r.height > window.innerHeight * 0.4) continue;
      if (r.top > 1 || r.bottom <= 0) continue;
      out.push(r.bottom);
    }
    return out;
  }

  /* The element list only needs walking when the page changes shape; on scroll
     we re-read the one element we settled on. */
  var pinned = null;
  function measure(deep){
    var gap = 0;
    if (deep || !pinned){
      var tops = candidates();
      gap = tops.length ? Math.max.apply(null, tops) : 0;
      pinned = null;
      if (gap > 0){
        var all = document.body.querySelectorAll("*");
        for (var i = 0; i < all.length; i++){
          var r = all[i].getBoundingClientRect();
          if (Math.abs(r.bottom - gap) < 0.5 && r.width >= window.innerWidth * 0.9){ pinned = all[i]; break; }
        }
      }
    } else {
      var pr = pinned.getBoundingClientRect();
      gap = (pr.top > 1 || pr.bottom <= 0) ? 0 : pr.bottom;
    }
    gap = Math.max(0, Math.round(gap));
    if (gap === last) return;
    last = gap;
    document.documentElement.style.setProperty("--dd-topgap", gap + "px");
  }

  var ticking = false;
  function onScroll(){ ticking = false; measure(false); }
  window.addEventListener("scroll", function(){
    if (!ticking){ ticking = true; requestAnimationFrame(onScroll); }
  }, { passive:true });
  window.addEventListener("resize", function(){ measure(true); }, { passive:true });
  measure(true);
  /* A theme header that loads its own web fonts settles a beat after we do. */
  setTimeout(function(){ measure(true); }, 600);
})();

/* ============================================================ NAV */
(function(){
  var burger = $("#burger"), mob = $("#mobilenav");
  /* Everything below runs inside window.DD_INIT, so a null here does not fail
     a nav — it throws out of DD_INIT and takes the readings, the protocol and
     the ingredient modals with it. A page missing its own burger menu is a
     page embedded in a theme that supplies one. */
  if (!burger || !mob) return;
  burger.addEventListener("click", function(){
    var open = burger.getAttribute("aria-expanded") === "true";
    burger.setAttribute("aria-expanded", String(!open));
    mob.classList.toggle("open", !open);
  });
  $$("#mobilenav a").forEach(function(a){
    a.addEventListener("click", function(){ burger.setAttribute("aria-expanded","false"); mob.classList.remove("open"); });
  });

  var rail = $("#rail"), links = $$(".dd-nav a"), secs = links.map(function(a){ return document.querySelector(a.getAttribute("href")); });
  var ticking = false;
  function onScroll(){
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    rail.style.width = (max > 0 ? clamp(window.scrollY / max, 0, 1) * 100 : 0) + "%";
    var y = window.scrollY + 140, idx = 0;
    secs.forEach(function(s,i){ if (s && s.offsetTop <= y) idx = i; });
    links.forEach(function(a,i){ a.classList.toggle("on", i === idx); });
    ticking = false;
  }
  window.addEventListener("scroll", function(){ if(!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, {passive:true});
  onScroll();
})();

/* ============================================================ DATE + YEAR */
(function(){
  var d = new Date();
  var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var dn = $("#hcDate");
  if(dn) dn.textContent = "Assessed " + d.getDate() + " " + months[d.getMonth()].slice(0,3) + " " + d.getFullYear();
  $("#yr").textContent = String(d.getFullYear());
})();

/* ============================================================ HERO STACK
   Rows are derived from the code itself: an adult code spells its traits, so
   each letter gets a row paired with the axis it stands for. A teen code is not
   composed of letters, so it falls back to the four measured axes directly. */
(function(){
  var host = $("#hcStack");
  if(!host) return;

  function rowsFor(P){
    var code  = String((P && P.code) || "AOPB").replace(/-P$/, "");
    var parts = ddTitleParts(P), words = parts.words;
    var rows  = [];
    if(P && P.cohort !== "teen" && code.indexOf("-") < 0){
      var order = ["aging", "oil"];
      if(P.axis && P.axis.pigment) order.push("pig");
      if(P.axis && P.axis.inflammation) order.push("inf");
      var letters = code.split("");
      order.forEach(function(k, i){
        rows.push({ key:k, letter:letters[i] || AXMETA[k].name.charAt(0),
                    word:words[i] || AXMETA[k].name,
                    /* the severity belongs to the trait it was written against */
                    mod:(i === parts.modIndex ? parts.mod : null) });
      });
    } else {
      AX_ORDER.forEach(function(k){
        rows.push({ key:k, letter:AXMETA[k].name.charAt(0), word:AXMETA[k].read(AXVALS[k]) });
      });
    }
    return rows;
  }

  var fills = [], nums = [];
  function render(P){
    host.innerHTML = ""; fills = []; nums = [];
    rowsFor(P).forEach(function(r, i){
      var m = AXMETA[r.key], v = AXVALS[r.key], d = Math.abs(v - 50), lead = (r.key === AXLEAD);
      var row = el("div", "cr" + (lead ? " is-lead" : ""));

      var cell = el("div","cr__cell");
      cell.appendChild(el("span","cr__n", ("0" + (i + 1)).slice(-2)));
      cell.appendChild(el("span","cr__l", r.letter));
      row.appendChild(cell);

      var mid = el("div","cr__mid");
      var word = el("div","cr__word", r.word);
      /* Severity rides the word, not the axis line: "mild" describes the
         breakouts, while "strongest" below describes which axis leads. Two
         different facts, so they must not share a slot. */
      if(r.mod) word.appendChild(el("i","cr__mod", r.mod));
      mid.appendChild(word);
      var ax = el("div","cr__axis", m.name);
      if(lead){ var st = el("i",null,"strongest"); ax.appendChild(st); }
      mid.appendChild(ax);
      row.appendChild(mid);

      var meter = el("div","cr__meter");
      var track = el("div","cr__track");
      [25,75].forEach(function(x){ var t = el("span","cr__tick"); t.style.left = x + "%"; track.appendChild(t); });
      track.appendChild(el("span","cr__mid-tick"));
      var fill = el("i","cr__fill");
      fill.style.left = (v >= 50 ? 50 : 50 - d) + "%";
      fill.setAttribute("data-w", d + "%");
      track.appendChild(fill);
      meter.appendChild(track);
      var poles = el("div","cr__poles");
      var L = el("span",null,m.left), R = el("span",null,m.right);
      (v >= 50 ? R : L).classList.add("on");
      poles.appendChild(L); poles.appendChild(R);
      meter.appendChild(poles);
      row.appendChild(meter);

      var read = el("div","cr__read");
      read.appendChild(el("b",null,m.read(v)));
      var num = el("span",null,"0");
      num.appendChild(el("i",null,"%"));
      read.appendChild(num);
      row.appendChild(read);

      host.appendChild(row);
      fills.push(fill); nums.push({ node:num, v:v });
    });
  }
  render(P);
  window.__ddRenderStack = render;

  var shown = false;
  function reveal(){
    if(shown) return;
    shown = true;
    fills.forEach(function(f){ f.style.width = f.getAttribute("data-w"); });
    function setNum(n, val){
      n.node.firstChild.nodeValue = String(Math.round(val));
    }
    if(reduced){ nums.forEach(function(n){ setNum(n, n.v); }); return; }
    var t0 = performance.now();
    (function step(now){
      var k = Math.min(1, (now - t0) / 900), e = 1 - Math.pow(1 - k, 3);
      nums.forEach(function(n){ setNum(n, n.v * e); });
      if(k < 1) requestAnimationFrame(step);
    })(t0);
  }
  window.__ddRevealResult = reveal;
  var overlay = document.getElementById("boot");
  if(!overlay || reduced) reveal(); else setTimeout(reveal, 12000);
})();

/* ============================================================ ELEMENTS + MODAL */
(function(){
  var host = $("#elements");
  ELEMENTS.forEach(function(e, i){
    var b = el("button","dd-el");
    b.type = "button";
    b.setAttribute("data-el", String(i));
    b.setAttribute("aria-haspopup","dialog");
    b.innerHTML =
      '<span class="dd-el__n">' + String(i + 1).padStart(2,"0") + '</span>' +
      '<span class="dd-el__c"></span>' +
      '<span class="dd-el__nm"></span>' +
      '<span class="dd-el__sub"></span>' +
      '<span class="dd-el__role"></span>' +
      '<span class="dd-el__bar"></span>';
    $(".dd-el__c", b).textContent   = e.code;
    $(".dd-el__nm", b).textContent  = e.name;
    $(".dd-el__sub", b).textContent = e.sub;
    $(".dd-el__role", b).textContent= e.role;
    host.appendChild(b);
  });

  var modal = $("#modal"), box = $("#modal-box"), opener = null;

  function paintModal(e){
    $("#modal-code").textContent = e.code || "";
    $("#modal-title").textContent = e.name || "";
    /* an empty <em></em> is not a subtitle — drop parts with no words in them */
    var sub = [e.sub, e.role].filter(ddHasText).map(ddRich).join(" · ");
    $("#modal-sub").innerHTML = sub;
    $("#modal-sub").hidden = !sub;
    $("#modal-body").innerHTML = ddRich(e.body || "");

    var fx = $("#modal-effects"); fx.innerHTML = "";
    (e.effects||[]).forEach(function(t){
      var li = el("li"); li.innerHTML = ddRich(t); fx.appendChild(li);
    });
    fx.parentNode.hidden = !(e.effects && e.effects.length);

    var cd = $("#modal-conditions"); cd.innerHTML = "";
    var cn = e.conditions || [];
    if(Array.isArray(cn)) cn = { chips: cn };   /* the built-in fallbacks are plain arrays */
    var rows = cn.rows || [], chips = cn.chips || [];
    cd.className = rows.length ? "dd-condrows" : "dd-tagrow";
    if(rows.length){
      var ul = el("ul");
      rows.forEach(function(h){ var li = el("li"); li.innerHTML = h; ul.appendChild(li); });
      cd.appendChild(ul);
    }
    chips.forEach(function(t){ cd.appendChild(el("span","dd-tag",t)); });
    cd.parentNode.hidden = !(rows.length || chips.length);

    /* Written for most of the library and, until now, rendered by nothing:
       hydrate() fetched benefits and then dropped it, and the pharmacology was
       never asked for at all. An empty section is hidden rather than left as a
       heading over nothing, which reads as a broken panel. */
    ["benefits", "pd", "pk"].forEach(function(k){
      var node = $("#modal-" + k);
      var v = String(e[k] || "").trim();
      node.innerHTML = v ? ddRich(v) : "";
      node.parentNode.hidden = !v;
    });

    var rf = $("#modal-refs"); rf.innerHTML = "";
    (e.refs||[]).forEach(function(t){ rf.appendChild(el("li",null,t)); });
    rf.parentNode.hidden = !(e.refs && e.refs.length);
  }

  /* The pharmacology is written once, in the ingredient library, and fetched
     the first time someone opens that active — not six times on page load for
     modals most readers never open. */
  function hydrate(e){
    if(e.loaded || !e.slug || typeof fetch !== "function") return Promise.resolve(e);
    e.loaded = true;
    /* Resolved here, not read from a shared constant. `DD_API` was assigned in
       the standalone bootstrap at the foot of this file — the one block
       build-section.py deliberately does NOT copy into dd2-app.js — so in the
       Shopify section this line threw "DD_API is not defined" on every click
       and the modal silently kept its built-in text. It read as a design that
       was simply less detailed than the other one. */
    var base = (window.DD_API || "https://api.dermalhealth.store").replace(/\/+$/, "");
    return fetch(base + "/v1/ingredient/" + encodeURIComponent(e.slug))
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(d){
        e.sub  = d.inci_name || "";
        e.role = d.depth_summary || "";
        if(d.description) e.body = d.description;
        e.effects = (d.moa||[]).map(function(m){
          return m.category + " — " + m.description; });
        if(!e.effects.length && d.physiological_effects)
          e.effects = [d.physiological_effects];
        e.benefits = d.benefits || "";
        e.pd = d.pharmacodynamics || "";
        e.pk = d.pharmacokinetics || "";
        e.conditions = ddConditions(d.managing_conditions);
        e.refs = String(d.references_text||"").split(/\n/)
          .map(function(x){ return x.trim(); }).filter(Boolean);
        return e;
      })
      .catch(function(){ return e; });
  }

  function open(i){
    var e = ELEMENTS[i];
    paintModal(e);
    hydrate(e).then(function(x){ if(!modal.hidden) paintModal(x); });

    modal.hidden = false;
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
    box.scrollTop = 0;
    box.focus();
  }
  function close(){
    modal.classList.remove("open");
    modal.hidden = true;
    document.body.style.overflow = "";
    if (opener) opener.focus();
  }

  host.addEventListener("click", function(ev){
    var b = ev.target.closest("[data-el]");
    if (!b) return;
    opener = b;
    open(parseInt(b.getAttribute("data-el"), 10));
  });
  $$("[data-close]").forEach(function(b){ b.addEventListener("click", close); });
  document.addEventListener("keydown", function(ev){ if (ev.key === "Escape" && modal.classList.contains("open")) close(); });
})();

/* ============================================================ PROTOCOL TABS */
(function(){
  var tabs = [$("#tab-am"), $("#tab-pm")];
  var panels = [$("#panel-am"), $("#panel-pm")];
  function select(i){
    tabs.forEach(function(t,j){ t.setAttribute("aria-selected", String(j === i)); });
    panels.forEach(function(p,j){ p.hidden = j !== i; });
  }
  tabs.forEach(function(t,i){
    t.addEventListener("click", function(){ select(i); });
    t.addEventListener("keydown", function(ev){
      if (ev.key === "ArrowRight" || ev.key === "ArrowLeft"){
        ev.preventDefault();
        var n = (i + (ev.key === "ArrowRight" ? 1 : 1)) % 2;
        select(n); tabs[n].focus();
      }
    });
  });

  $$("[data-intensify]").forEach(function(btn){
    btn.addEventListener("click", function(){
      var box = btn.closest(".dd-intensify");
      var open = box.getAttribute("data-open") === "true";
      box.setAttribute("data-open", String(!open));
      btn.setAttribute("aria-expanded", String(!open));
    });
  });
})();

/* ============================================================ PACK BUILDER */
(function(){
  /* The pack is priced by Shopify, never here. Two reasons it has to be:
     the same pack costs different money in South Africa, Namibia and the rest
     of the world, and a dispensing practice sees its own catalogue price. Only
     the storefront the customer is actually standing in knows which applies.
     So this asks Shopify's Ajax API — relative URL, so it answers correctly on
     dermalhealth.store and dermal.store alike — and if it cannot (the page
     opened as a standalone file, say) it hides the money rather than inventing
     a number. */
  var state = { size:"100", spf:"1" };
  var bom = $("#bom");
  var packHandle = (P && P.pack && P.pack.handle) || null;
  var packSku    = (P && P.pack && P.pack.sku) || null;
  var priceOf = {};          /* product handle -> price in rand */
  var packPrice = null;      /* {now, was} for the selected variant */
  var packVariantId = null;  /* the variant id the toggles resolve to */
  var packAvailable = true;

  function items(){ return (P && P.pack && P.pack.items) || []; }
  function hasGroup(g){ return items().some(function(i){ return i.variant_group===g; }); }

  /* the lines the customer is actually being sent, given the toggles */
  function lineup(){
    var seen = {};
    return items().filter(function(it){
      if(it.variant_group === "cleanser_size") return it.variant_value === state.size;
      if(it.variant_group === "sunscreen")     return true;   /* rendered, dimmed when excluded */
      if(!it.variant_group){ if(seen[it.handle]) return false; seen[it.handle]=1; }
      return true;
    });
  }

  function money2(c){ return money(Math.round(c/100)); }

  /* expected variant SKU: DD-AOPB → DD-AOPB175-C, keeping any -P suffix */
  function wantSku(){
    if(!packSku) return null;
    var m = /^(.*?)(-P)?$/.exec(packSku);
    return m[1] + (state.size==="175" ? "175" : "") + (state.spf==="0" ? "-C" : "") + (m[2]||"");
  }

  function render(){
    var rows = lineup();
    bom.innerHTML = "";
    rows.forEach(function(it){
      var off = (it.variant_group==="sunscreen" && state.spf==="0");
      var r = el("div","dd-bom__row");
      if(off) r.setAttribute("data-off","true");
      var nm = el("div","dd-bom__nm");
      nm.appendChild(document.createTextNode(it.title || it.handle));
      nm.appendChild(el("small", null, (it.size_label||"") + (off ? " · not included" : "")));
      r.appendChild(nm);
      var pv = priceOf[it.handle];
      r.appendChild(el("div","dd-bom__p", pv!=null ? ("R " + money2(pv)) : " "));
      bom.appendChild(r);
    });

    var count = rows.filter(function(it){
      return !(it.variant_group==="sunscreen" && state.spf==="0"); }).length;
    $("#pk-count").textContent = String(count);

    var total = $(".dd-total"), fine = $(".dd-buy__fine");
    if(packPrice){
      total.hidden = false;
      $("#pk-was").textContent = packPrice.was ? money2(packPrice.was) : money2(packPrice.now);
      $("#pk-now").textContent = money2(packPrice.now);
      var save = (packPrice.was||0) - packPrice.now;
      $("#pk-save").textContent = money2(save > 0 ? save : 0);
      $("#pk-pct").textContent  = packPrice.was ? String(Math.round(100*save/packPrice.was)) : "0";
      $(".dd-total__was").hidden = !(packPrice.was && save>0);
      $(".dd-total__save").hidden = !(packPrice.was && save>0);
      if(fine) fine.textContent = "Priced for this store, including VAT. Your practice or region may change what you see.";
    } else {
      total.hidden = true;
      if(fine) fine.textContent = "Open the pack to see pricing for your region.";
    }
    var sk = wantSku();
    if(sk) $("#pk-sku").textContent = "SKU · " + sk;
  }

  /* Shopify's Ajax API: /products/<handle>.js — market and catalogue aware. */
  function shopify(handle){
    return fetch("/products/" + handle + ".js", {headers:{accept:"application/json"}})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); });
  }

  function loadPrices(){
    if(!packHandle) return;
    var jobs = [ shopify(packHandle).then(function(d){
      var want = wantSku(), v = null;
      for(var i=0;i<d.variants.length;i++){
        if(d.variants[i].sku === want){ v = d.variants[i]; break; }
      }
      if(!v) v = d.variants[0];
      packPrice = { now: v.price, was: v.compare_at_price || null };
      /* The variant the customer is actually buying, resolved by SKU from the
         toggles. Adding to the cart needs its id, not its price, and taking
         variants[0] would quietly sell the 100 ml pack to someone who chose
         175 ml. */
      packVariantId = v.id || null;
      packAvailable = v.available !== false;
    }).catch(function(){ packPrice = null; packVariantId = null; }) ];

    items().forEach(function(it){
      if(priceOf[it.handle] != null) return;
      jobs.push(shopify(it.handle).then(function(d){
        var v = d.variants[0];
        if(it.variant_value){
          for(var i=0;i<d.variants.length;i++){
            var t = String(d.variants[i].title||"").replace(/\s|ml/gi,"");
            if(t === String(it.variant_value)) { v = d.variants[i]; break; }
          }
        }
        priceOf[it.handle] = v.price;
      }).catch(function(){}));
    });
    return Promise.all(jobs).then(render, render);
  }

  /* a toggle with nothing to toggle is noise — hide it */
  var opts = $$(".dd-opt");
  if(opts[0] && !hasGroup("cleanser_size")) opts[0].hidden = true;
  if(opts[1] && !hasGroup("sunscreen"))     opts[1].hidden = true;

  $$("[data-opt]").forEach(function(b){
    b.addEventListener("click", function(){
      state[b.getAttribute("data-opt")] = b.getAttribute("data-val");
      b.parentNode.querySelectorAll("[data-opt]").forEach(function(s){
        s.setAttribute("aria-checked", String(s === b));
      });
      render();
      if(packHandle) loadPrices();
    });
  });

  render();
  if(packHandle && typeof fetch === "function") loadPrices();

  /* ---------- the cart ----------
     "Add pack to cart" used to navigate to /products/<handle>, which is a
     product page, not a cart. The customer read a personalised protocol, chose
     a cleanser size and decided to buy, and was handed a page asking them to
     choose all of it again.

     So the primary button adds, and stays put: a treatment plan is a long
     document and people are still reading it. The product page is still one
     click away as the secondary action, for anyone who wants the full detail.

     Everything here degrades rather than breaks. /cart/add.js only exists on a
     Shopify storefront; on the worker preview domain, or as a saved file, the
     fetch fails and the button falls back to the product link — which is where
     it used to go anyway, so the worst case is the old behaviour. */
  var add      = $("[data-add]");
  var packLink = $("[data-packlink]");
  var msg      = $(".dd-buy__msg");

  if(packLink && packHandle){
    packLink.href = "/products/" + packHandle;
    packLink.hidden = false;
  }

  function say(text, isError){
    if(!msg) return;
    msg.textContent = "";
    if(!text) { msg.removeAttribute("data-err"); return; }
    if(isError) msg.setAttribute("data-err","true"); else msg.removeAttribute("data-err");
    msg.appendChild(document.createTextNode(text));
  }
  function sayAdded(){
    if(!msg) return;
    msg.removeAttribute("data-err");
    msg.textContent = "";
    msg.appendChild(document.createTextNode("Your pack is in the cart. "));
    var a = document.createElement("a");
    a.href = "/cart"; a.textContent = "View cart";
    msg.appendChild(a);
    msg.appendChild(document.createTextNode(" when you are ready."));
  }
  /* Open the store's own cart drawer, so the customer sees the pack land
     rather than having to take our word for it.

     The theme on this store is a Maestrooo one: it puts <cart-drawer
     id="CartDrawer"> in the page, refreshes its contents from a `cart:refresh`
     event on <html>, and exposes show() to open it. We refresh first, then
     open a beat later so the drawer slides out with the new line already in
     it rather than re-rendering in front of the customer.

     Every step is optional. If there is no drawer we click the header's own
     drawer TOGGLE — matched on aria-controls, never a plain /cart link, so a
     miss can never navigate the page away from a plan the customer is still
     reading. If there is no toggle either, the line of text under the button
     is the confirmation, which is why it is written before any of this runs
     and not instead of it. */
  function showCart(){
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles:true, detail:{ source:"dermal-diagnosis" } }));
    } catch(e){}
    setTimeout(function(){
      try {
        var d = document.getElementById("CartDrawer") || document.querySelector("cart-drawer");
        if (d && typeof d.show === "function") { d.show(); return; }
        var toggles = document.querySelectorAll("[aria-controls]");
        for (var i = 0; i < toggles.length; i++){
          var ac = toggles[i].getAttribute("aria-controls") || "";
          if (/cart/i.test(ac) && !/recently/i.test(ac) && toggles[i].offsetParent !== null){
            toggles[i].click(); return;
          }
        }
      } catch(e){}
    }, 140);
  }

  function label(v){ if(add && add.firstChild) add.firstChild.nodeValue = v; }
  function reset(){
    if(!add) return;
    add.disabled = false; label("Add pack to cart"); say(null);
  }

  /* Changing a toggle after adding makes the button live again: the pack in
     the cart is no longer the pack on the screen, and a disabled "Added"
     button next to a different configuration is a trap. */
  $$("[data-opt]").forEach(function(b){
    b.addEventListener("click", function(){ if(add && add.disabled) reset(); });
  });

  if(add) add.addEventListener("click", function(){
    if(!packHandle){
      this.disabled = true; label("Pack not linked yet");
      setTimeout(reset, 2200);
      return;
    }
    if(!packVariantId || typeof fetch !== "function"){
      /* Prices never loaded, so neither did the variant: hand them to the
         product page rather than guessing at an id. */
      window.location.href = "/products/" + packHandle;
      return;
    }
    var b = this;
    b.disabled = true; label("Adding\u2026"); say(null);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", accept: "application/json" },
      body: JSON.stringify({ items: [{ id: packVariantId, quantity: 1 }] })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw e; }, function(){ throw 0; });
      return r.json();
    }).then(function(){
      label("Added to cart");
      sayAdded();
      showCart();
    }).catch(function(err){
      b.disabled = false; label("Add pack to cart");
      var m = err && (err.description || err.message);
      say(m ? String(m) : "That did not go through. Open the pack to add it.", true);
    });
  });
})();

/* ============================================================ TIMELINE BARS */
(function(){
  var bars = $$("[data-tlbar]");
  function fill(){ bars.forEach(function(b){ b.style.width = b.getAttribute("data-tlbar") + "%"; }); }
  if (reduced || !("IntersectionObserver" in window)) { fill(); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){ en.target.style.width = en.target.getAttribute("data-tlbar") + "%"; io.unobserve(en.target); }
    });
  }, { threshold:0.4 });
  bars.forEach(function(b){ io.observe(b); });
})();


/* ============================================================ PRINTED PLAN
   The sheet itself is dd-print.js, shared with design 1 — one clinical
   document, not two that are free to disagree.

   This page holds its data in a different shape from the old design (one
   protocol from /v1/diagnosis plus the record, rather than the bundled content
   store), so DD_PRINT.fromRecord() translates. The translation lives in
   dd-print.js because that is where the shape it translates INTO is defined.

   No record means no plan to print: ?code= previews a protocol with sample
   readings, and a downloadable "treatment plan" carrying invented percentages
   is exactly the document that must not exist. The button stays hidden. */
(function(){
  var btn = $("#ddPrintBtn");
  if (!btn || !window.DD_PRINT) return;
  var rec = window.DD_RECORD;

  /* The section's Test display setting turns the button on WITHOUT a record,
     so the printed sheet can be laid out against any of the 69 protocols
     instead of only the handful there happen to be tokens for. The guard above
     still holds — what it exists to prevent is a plausible-looking treatment
     plan escaping with invented percentages on it, and DD_SAMPLE_PLAN makes
     dd-print.js stamp the sheet before the code. A ?code= preview, which
     anyone can reach by typing a URL, still gets no button at all. */
  var sample = !rec && window.DD_SAMPLE_PLAN === true;
  if (!sample && (!rec || !rec.ok)) return;

  /* The same four numbers the hero is showing, so the sheet and the screen do
     not disagree in front of you. Reactivity is the maximum of the four
     inflammatory readings, so standing it in for each of them is the closest
     honest thing to do with a sample — and the stamp says it is one. */
  function sampleRecord(){
    var inf = AXVALS.inf;
    return { ok:true, result_code:(P && P.code) || "", submitted_at:new Date().toISOString(),
      profile:{ aging_perc:AXVALS.aging, hyd_perc:AXVALS.oil, pigm_perc:AXVALS.pig,
                acne_perc:inf, ros_perc:inf, allergy_perc:inf, sens_perc:inf } };
  }

  var src = rec || sampleRecord();
  try {
    var printer = window.DD_PRINT.mount(function(){
      return window.DD_PRINT.fromRecord(src, P);
    });
    btn.addEventListener("click", printer.print);
    /* The LABEL, not the button: btn.textContent would replace the icon with
       a text node and the button would lose its glyph the moment the copy
       table answered. */
    var plabel = btn.querySelector(".dd-print__t");
    var ptext = window.DD_PRINT.copy("cta.topbar") || "Download plan";
    if (plabel) plabel.textContent = ptext;
    btn.setAttribute("aria-label", ptext);
    btn.setAttribute("title", ptext);
    btn.hidden = false;
  } catch (e) {
    if (window.console) console.error("[dd] printed plan unavailable", e);
  }
})();

};

/* ============================================================
   ANALYSIS SEQUENCE
   Five beats, each showing something the engine actually does:
   the responses, the calculation set, the four axes, the
   narrowing of 39 profiles to one, then the code itself.
   ============================================================ */
window.DD_BOOT = function(P){
"use strict";

var boot = document.getElementById("boot");
if (!boot) return;

/* The reveal is a 12-second animation. Watching it on every refresh while
   laying the page out is its own small torture, so the section's "Skip the
   reveal" setting raises this flag and takes the same branch a reader with
   prefers-reduced-motion already takes — one code path, already proven,
   rather than a second way of arriving at a revealed page. */
var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
              || window.DD_SKIP_REVEAL === true;
var $  = function(s){ return document.querySelector(s); };
var timers = [];
function at(ms, fn){ timers.push(setTimeout(fn, ms)); }
function clearAll(){ timers.forEach(clearTimeout); timers = []; }

/* every code in the library, in the order the engine narrows them */
var TEEN = ["TEEN-HEALTHY","TEEN-CONGESTED","TEEN-BREAKOUTS","TEEN-MILD","TEEN-FOLLICULITIS",
            "TEEN-ACNE-1","TEEN-ACNE-2","TEEN-ACNE-3","TEEN-ACNE-4","TEEN-DRY-ALLERGY","TEEN-OILY-ALLERGY"];
var DRY  = ["AD","ADP","ADPR","ADPB","ADPBM","ADPBF","ADPA","ADPS","ADR","ADB","ADBM","ADBF","ADA","ADS"];
var OILY = ["AO","AOR","AOB","AOBM","AOBF","AOA","AOS","AOP","AOPR","AOPB","AOPBM","AOPBF","AOPA","AOPS"];
var SHORT = {
  "TEEN-HEALTHY":"TN·HLT","TEEN-CONGESTED":"TN·CNG","TEEN-BREAKOUTS":"TN·BRK","TEEN-MILD":"TN·MLD",
  "TEEN-FOLLICULITIS":"TN·FOL","TEEN-ACNE-1":"TN·AC1","TEEN-ACNE-2":"TN·AC2","TEEN-ACNE-3":"TN·AC3",
  "TEEN-ACNE-4":"TN·AC4","TEEN-DRY-ALLERGY":"TN·DAL","TEEN-OILY-ALLERGY":"TN·OAL"
};
var ALL = DRY.concat(OILY, TEEN);

/* Build the elimination sequence for one code: cohort, then hydration axis,
   then pigment, then inflammatory subtype — the order the engine works in. */
function narrowPlan(T){
  var pool = ALL.slice(), steps = [];
  function cut(list, label){
    var rm = pool.filter(function(c){ return list.indexOf(c) > -1 && c !== T; });
    pool = pool.filter(function(c){ return rm.indexOf(c) < 0; });
    steps.push({ rm: rm, label: label, remain: pool.length });
  }
  if(T.indexOf("TEEN") === 0){
    cut(DRY.concat(OILY), "Under twenty");
    var acne = /ACNE/.test(T);
    cut(TEEN.filter(function(c){ return /ACNE/.test(c) !== acne; }), "Severity ladder");
    cut(TEEN, "Grade matched");
  } else {
    cut(TEEN, "Adult protocols");
    var oily = T.charAt(1) === "O", grp = oily ? OILY : DRY;
    cut(oily ? DRY : OILY, oily ? "Oily, not dry" : "Dry, not oily");
    var pig = T.charAt(2) === "P";
    cut(grp.filter(function(c){ return (c.charAt(2) === "P") !== pig; }),
        pig ? "Pigment expressed" : "No pigment axis");
    cut(grp, "Inflammatory subtype");
  }
  return steps;
}

/* The reveal spells out whichever code this reader actually got. Adult codes
   are one letter per trait; a teen code is not composed of letters at all, so
   it reveals segment by segment instead. */
var TARGET = (P && P.code) || "AOPB";
var BASE   = TARGET.replace(/-P$/, "");          /* pregnancy variants share a grid cell */
var TWORDS = P && P.title ? String(P.title).split(".").map(function(w){ return w.trim(); }).filter(Boolean) : [];
var LETTERS = (function(){
  if(BASE.indexOf("TEEN") === 0){
    return BASE.split("-").map(function(seg){ return [seg.charAt(0), seg]; });
  }
  var ch = BASE.split("");
  return ch.map(function(c, i){ return [c, TWORDS[i] || ""]; });
})();

/* ---------------- build the static furniture ---------------- */
var NARROW = narrowPlan(BASE);
try{ $("#boot-name").textContent = TWORDS.join(" · ") || BASE; }catch(e){}
var dots = $("#boot-dots");
for (var i = 0; i < 100; i++) dots.appendChild(document.createElement("i"));
var dotEls = dots.children;

var gridHost = $("#boot-grid"), codeEls = {};
ALL.forEach(function(c){
  var n = document.createElement("div");
  n.className = "dd-boot__code";
  n.textContent = SHORT[c] || c;
  gridHost.appendChild(n);
  codeEls[c] = n;
});

var letterHost = $("#boot-letters"), letterEls = [];
LETTERS.forEach(function(L){
  var n = document.createElement("div");
  n.className = "dd-boot__ltr";
  n.appendChild(document.createTextNode(L[0]));
  var s = document.createElement("small"); s.textContent = L[1];
  n.appendChild(s);
  letterHost.appendChild(n);
  letterEls.push(n);
});

/* axis mini-bars — the same four values the page will show */
var AXV = (window.DD_AXES_PREVIEW || [
  {name:"Hydration", v:71, read:"Oily"},
  {name:"Reactivity", v:66, read:"Inflamed"},
  {name:"Pigment",   v:64, read:"Pigmented"},
  {name:"Firmness",  v:78, read:"Aging"}
]);
var axHost = $("#boot-axes"), axBars = [];
AXV.forEach(function(a){
  var row = document.createElement("div");
  row.className = "dd-boot__ax";
  var s = document.createElement("span"); s.textContent = a.name;
  var u = document.createElement("u");
  var d = Math.abs(a.v - 50);
  u.style.setProperty("--l", (a.v >= 50 ? 50 : 50 - d) + "%");
  u.style.setProperty("--w", d + "%");
  var em = document.createElement("em"); em.textContent = Math.round(a.v) + "%";
  row.appendChild(s); row.appendChild(u); row.appendChild(em);
  axHost.appendChild(row);
  axBars.push(u);
});

/* ---------------- helpers ---------------- */
var layers = Array.prototype.slice.call(document.querySelectorAll(".dd-boot__layer"));
var current = -1;
function show(i){
  layers.forEach(function(l, j){
    l.classList.toggle("on", j === i);
    l.classList.toggle("out", j < i);
  });
  current = i;
}
function say(html){ $("#boot-say").innerHTML = html; }
function bar(pct){ $("#boot-bar").style.width = pct + "%"; }

function countTo(node, target, ms){
  var start = performance.now();
  (function step(now){
    var t = Math.min(1, (now - start) / ms);
    var eased = 1 - Math.pow(1 - t, 3);
    node.textContent = Math.round(target * eased);
    if (t < 1) requestAnimationFrame(step);
  })(start);
}

/* greet by name when the assessment passes one through */
var firstName = "";
try {
  var n = new URLSearchParams(window.location.search).get("first_name");
  if (n) firstName = n.trim().replace(/[<>&"]/g, "").slice(0, 24);
} catch(e){}

/* ---------------- the timeline ---------------- */
function run(){
  bar(4);

  /* 1 · responses */
  say(firstName
    ? "Reading " + firstName + "&rsquo;s <em>responses</em>"
    : "Reading your <em>responses</em>");
  show(0);
  for (var k = 0; k < 100; k++){
    (function(k){ at(90 + k * 6, function(){ dotEls[k].classList.add("on"); }); })(k);
  }
  at(260, function(){ bar(20); });

  /* 2 · the calculation set */
  at(820, function(){
    say("Resolving the <em>calculation</em> set");
    show(1);
    countTo($("#boot-calc"), 71, 650);
    countTo($("#boot-cond"), 276, 800);
    bar(40);
  });
  at(1400, function(){ $("#boot-iter").innerHTML = "Iteration <b>2</b>"; });
  at(1660, function(){ $("#boot-iter").innerHTML = "Iteration <b>3</b> &middot; stable"; });

  /* 3 · the four axes */
  at(1980, function(){
    say("Placing you on <em>four</em> axes");
    show(2);
    bar(58);
    axBars.forEach(function(u, j){ at(j * 150, function(){ u.setAttribute("data-fill",""); }); });
  });

  /* 4 · narrowing the library */
  at(3020, function(){
    say("Matching against the <em>profile</em> library");
    show(3);
    bar(72);
  });
  /* The narrowing is computed from the reader's own code, not scripted for one
     of them. Each cut removes everything the answers ruled out and says why. */
  NARROW.forEach(function(step, i){
    at(3340 + i * 380, function(){
      step.rm.forEach(function(c){ if(codeEls[c]) codeEls[c].classList.add("gone"); });
      if(step.remain === 1 && codeEls[BASE]) codeEls[BASE].classList.add("hit");
      $("#boot-cut").innerHTML = step.label + " &middot; <b>" + step.remain + "</b> " +
        (step.remain === 1 ? "match" : "remain");
      if(i === NARROW.length - 2) bar(82);
      if(i === NARROW.length - 1) bar(92);
    });
  });

  /* 5 · the reveal */
  at(5020, function(){
    say(firstName ? firstName + ", this is <em>your</em> skin" : "This is <em>your</em> skin");
    show(4);
    bar(100);
    letterEls.forEach(function(n, j){ at(j * 110, function(){ n.classList.add("in"); }); });
    at(600, function(){ $("#boot-name").classList.add("in"); });
  });

  at(6250, finish);
}

/* ---------------- exit ---------------- */
var done = false;
function finish(){
  if (done) return;
  done = true;
  clearAll();
  boot.setAttribute("data-state","done");
  document.body.style.overflow = "";
  document.body.classList.remove("dd-armed");
  document.body.classList.add("dd-revealed");
  if (typeof window.__ddRevealResult === "function") window.__ddRevealResult();
  setTimeout(function(){ boot.hidden = true; }, 800);
}

function start(){
  done = false;
  clearAll();
  boot.hidden = false;
  boot.setAttribute("data-state","run");
  document.body.style.overflow = "hidden";
  document.body.classList.add("dd-armed");
  document.body.classList.remove("dd-revealed");
  /* reset every stage */
  Array.prototype.forEach.call(dotEls, function(d){ d.classList.remove("on"); });
  ALL.forEach(function(c){ codeEls[c].classList.remove("gone","hit"); });
  axBars.forEach(function(u){ u.removeAttribute("data-fill"); });
  letterEls.forEach(function(n){ n.classList.remove("in"); });
  $("#boot-name").classList.remove("in");
  $("#boot-calc").textContent = "0"; $("#boot-cond").textContent = "0";
  $("#boot-iter").innerHTML = "Iteration <b>1</b>";
  $("#boot-cut").textContent = "39 profiles";
  window.scrollTo(0, 0);
  requestAnimationFrame(run);
  try { $("#boot-skip").focus({ preventScroll:true }); } catch(e){}
}

$("#boot-skip").addEventListener("click", finish);
document.addEventListener("keydown", function(e){
  if ((e.key === "Escape" || e.key === "Enter") && !done) finish();
});

var replay = document.querySelector("[data-replay]");
if (replay) replay.addEventListener("click", function(){ start(); });

if (reduced){
  boot.hidden = true;
  document.body.classList.add("dd-revealed");
  if (typeof window.__ddRevealResult === "function") window.__ddRevealResult();
} else {
  document.body.classList.add("dd-armed");
  document.body.style.overflow = "hidden";
  requestAnimationFrame(run);
  try { $("#boot-skip").focus({ preventScroll:true }); } catch(e){}
}
};
